import { PropsWithChildren } from "react";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/sidebar/AppSidebar";
import { Menu } from "lucide-react";
import { SkipToContent } from "@/components/SkipToContent";

export function AppShell({ children }: PropsWithChildren) {
  return (
    <SidebarProvider defaultOpen>
      <SkipToContent />
      <AppSidebar />
      <SidebarInset id="main-content" className="bg-background">
        {children}
      </SidebarInset>
      
      {/* Floating mobile menu button - bottom left */}
      <SidebarTrigger className="fixed bottom-4 left-4 z-50 md:hidden h-12 w-12 rounded-full bg-[#0a0f1a]/90 backdrop-blur-md border border-white/10 shadow-lg text-white hover:bg-[#0a0f1a] hover:text-white">
        <Menu className="h-5 w-5" />
      </SidebarTrigger>
    </SidebarProvider>
  );
}
